import styled from 'styled-components';

export const SectionContainer = styled.div`
    background: #ffffff;
    display: flex;
    flex-direction: column;
    border: 1px solid #eef1f3;
    border-radius: 16px;
`;
